import React, { useState } from 'react'
import { Container, Accordion } from 'react-bootstrap';
import { useFAQS } from '../hooks/useFAQS';

function FAQ() {
  const { faqs, loading, error } = useFAQS();

  return (
    <div className="explore-result-locations common-padding">
      <Container>
        <div className="common-header text-center">
          <h2>Frequently asked questions</h2>
          <p>
            With over a million agents from all the top brokerages, a local agent knows your market
            and can guide you through the process from start to finish
          </p>
        </div>

        {loading && <p className="text-center">Loading FAQs...</p>}
        {error && <p className="text-center text-danger">Failed to load FAQs.</p>}

        {!loading && !error && (
          <Accordion defaultActiveKey="0">
            {faqs.map((faq, index) => (
              <Accordion.Item eventKey={String(index)} key={faq.id ?? index}>
                <Accordion.Header>
                  <h5 dangerouslySetInnerHTML={{ __html: faq.question || "" }} />
                </Accordion.Header>
                <Accordion.Body>
                  <p dangerouslySetInnerHTML={{ __html: faq.answer || "" }} />
                </Accordion.Body>
              </Accordion.Item>
            ))}
          </Accordion>
        )}
      </Container>
    </div>
  );
}

export default FAQ;